import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Meta, User } from 'utils/types';

import c from '../utils/constants';

interface Result {
  data: User[];
  meta: Meta;
}

export default function useGetAccountUsers(params = {}) {
  const { state } = useProvider();
  const args = state;

  const { accountId } = useAdminParams();

  return useQuery<Result, Error>({
    queryKey: [c.ACCOUNT_USERS, params],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/accounts/users/',
            params,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users`,
            params,
          },
        }),
      );

      return data;
    },
  });
}
